import React from "react";
import { useCanWrite } from "../hooks/useAccountConfig";

interface FirstTimeUserModalProps {
  show: boolean;
  isNXXGCrossAccount: boolean;
  onStartDemo: () => void;
  onExit: () => void;
}

const FirstTimeUserModal: React.FC<FirstTimeUserModalProps> = ({
  show,
  isNXXGCrossAccount,
  onStartDemo,
  onExit,
}) => {
  // DNC-390: activating the demo provisions the product on the account, so an
  // Agent may not do it. This modal gates every TrustCall route, so a disabled
  // "Start Demo Now" would leave an Agent on an unprovisioned account staring at
  // a dead button with Exit as their only move. Show them who to ask instead.
  // Called above the `show` early return so the hook runs unconditionally.
  const canWrite = useCanWrite();

  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">
              Would you like to purchase TrustCall&trade; Monitor?
            </h3>
          </div>
          <div className="modal-body">
            <div className="col-md-12">
              <h5>
                You are not currently subscribed to TrustCall&trade; Monitor<br />
                {!canWrite ? (
                  <>Ask an Admin or Supervisor on your account to activate TrustCall.</>
                ) : isNXXGCrossAccount ? (
                  <>Please contact <a href="mailto:Compliance@nexxagroup.com">Compliance@nexxagroup.com</a> to activate your services.</>
                ) : (
                  <>Please contact <a href="mailto:support@dnc.com">support@dnc.com</a> to add TrustCall to your account.</>
                )}
              </h5>
            </div>
            <div className="modal-footer">
              {canWrite && (
                <button className="btn btn-warning" onClick={onStartDemo}>
                  Start Demo Now
                </button>
              )}
              <button className="btn btn-secondary" onClick={onExit}>
                Exit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeUserModal;
